<template>
  <footer class="footer pt-3">
        <div class="container-fluid">
          <div class="row align-items-center justify-content-lg-between">
            <div class="col-lg-6 mb-lg-0 mb-4">
              <div class="copyright text-center text-sm text-muted text-lg-start">
                © {{new Date().getFullYear()}}
                ,
                made with <i class="fa fa-heart text-gradient"></i> by @K******.
              </div>
            </div>
            <div class="col-lg-6">
              <ul class="nav nav-footer justify-content-center justify-content-lg-end">
                <li class="nav-item">
                  <a href="https://t.me/+7JKA_DC1g_sxMzRi" class="nav-link pe-0 text-muted" target="_blank">FreeDash</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
</template>